(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["review-slider"] && !Shopify.designMode) return;
  try {
    function initReviewSliders() {
    document.querySelectorAll('[data-review-slider]').forEach(function (wrapper) {
      if (wrapper.dataset.sliderReady === 'true') return;
      wrapper.dataset.sliderReady = 'true';

      var cards = wrapper.querySelectorAll('.review-card');
      var nextBtn = wrapper.querySelector('.next');
      var prevBtn = wrapper.querySelector('.prev');

      if (cards.length === 0) {
        wrapper.style.display = 'none';
        return;
      }

      if (cards.length === 1) {
        if (nextBtn) nextBtn.style.display = 'none';
        if (prevBtn) prevBtn.style.display = 'none';
        return;
      }

      var currentIndex = 0;

      function showSlide(index) {
        cards.forEach(function (card) {
          card.classList.remove('active');
        });
        cards[index].classList.add('active');
      }

      showSlide(currentIndex);

      nextBtn.addEventListener('click', function () {
        currentIndex = (currentIndex + 1) % cards.length;
        showSlide(currentIndex);
      });

      prevBtn.addEventListener('click', function () {
        currentIndex = (currentIndex - 1 + cards.length) % cards.length;
        showSlide(currentIndex);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewSliders);
  } else {
    initReviewSliders();
  }

  document.addEventListener('shopify:section:load', initReviewSliders);
  } catch(e) { console.error(e); }
})();

})();
